const TOKEN_KEY = 'admin_token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return !!getToken();
}

async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    ...(options.headers as Record<string, string> || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    clearToken();
    window.location.href = '/admin/login';
    throw new Error('未授权');
  }

  if (!response.ok) {
    const error: any = await response.json().catch(() => ({ error: '请求失败' }));
    throw new Error(error.error || `请求失败 (${response.status})`);
  }

  // 如果是 vCard 下载，返回 blob
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('text/vcard')) {
    return response.blob() as unknown as T;
  }

  return response.json();
}

export const api = {
  get: <T>(url: string) => request<T>(url),
  post: <T>(url: string, data?: unknown) => request<T>(url, {
    method: 'POST',
    body: data instanceof FormData ? data : JSON.stringify(data),
  }),
  put: <T>(url: string, data: unknown) => request<T>(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  }),
  del: <T>(url: string, data?: unknown) => request<T>(url, {
    method: 'DELETE',
    body: data ? JSON.stringify(data) : undefined,
  }),
};
